<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <SubHeader title="Live Q&A" />
      <!-- //header -->
      <Gnb v-if="showGnb" />
      <!-- //header -->

      <div id="container" ref="container">
        <section id="contents">
          <div class="qnaWrap list-style">
            <div class="qnalistWrap">
              <div class="qnalistTitle">
                <div class="num">{{this.$store.getters.getQnaSubjectIndex}}</div>
                <div class="title">
                  <a href="#">{{this.$store.getters.getQnaSubjectTitle}}</a>
                  <!-- qna_kind_list -->
                </div>
              </div>
              <!-- qnalistTitle -->
              <div class="qnaWrite">
                <div class="qnaWriteTitle">
                  <h3>
                    작성자
                    <span>{{writer}}</span>
                  </h3>
                  <div class="checkbox">
                    <input type="checkbox" name="ex1_1" id="ex1_1" v-model="secret" />
                    <label for="ex1_1">닉네임 비공개</label>
                  </div>
                </div>
                <div class="qnaWriteCon">
                  <textarea
                    @keyup="cnt"
                    cols="30"
                    rows="10"
                    class="error"
                    placeholder="질문을 입력하세요. 욕설이나 부적절한 내용이 포함된 질문은 노출에 제한이 될 수 있습니다"
                    v-model="mtext"
                  ></textarea>
                  <span class="count">
                    <b>{{cCount}}</b> / 150
                  </span>
                </div>
              </div>
            </div>

            <div class="btnWrap">
              <a href="#" @click.prevent="goCancel">취소</a>
              <a href="#" @click.prevent="goSave">{{modeText}}</a>
            </div>
          </div>
          <!-- qnaWrap -->
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>


<script>
import SubHeader from "@/components/SubHeader";
import Gnb from "@/components/Gnb";
import sideMixin from "@/components/SideMixin";

export default {
  mixins: [sideMixin],
  components: { SubHeader, Gnb },

  created() {
    this.qnaid = null;
    // this.mtext = null;
    this.isSecret = false;

    let paperid = this.$route.params.paperid;
    this.$store.dispatch("loadQnaMeta", paperid);

    let qnaid = this.$route.params.qnaid;

    if (qnaid !== undefined) {
      this.$store.dispatch("loadQnaView", qnaid);
    } else {
      this.$store.dispatch("blankQnaview");
    }
  },
  data: function() {
    return {
      isSecret: false,
      ktext: null,
      qnaid: this.$store.getters.getQnaView.id,
      cCount: 0
    };
  },

  computed: {
    mtext: {
      cache: false,
      get: function() {
        return this.$store.getters.getQnaViewText;
      },
      set(value) {
        this.$store.commit("updateQnaViewText", value);
      }
    },
    remainText() {
      if (this.mtext == null) {
        return 0;
      }
      let cnt = this.mtext.length;
      return cnt;
    },
    secret: {
      cache: false,
      get: function() {
        return this.$store.getters.getQnaView.secret === 1 ? true : false;
      },
      set(value) {
        this.$store.state.qna_view.secret = value ? 1 : 0;
      }
    },

    writer() {
      return localStorage.getItem("default_info");
    },

    showGnb: function() {
      return this.$store.getters.getShowGnb;
    },
    qnaView: function() {
      return this.$store.gettters.getQnaView;
    },
    secret2: function() {
      return this.$store.getters.getQnaView.secret === 1 ? true : false;
    },
    modeText: function() {
      if (this.$store.getters.getQnaView.id === null) {
        return "등록";
      } else {
        return "수정";
      }
    }
  },
  methods: {
    cnt() {
      // let cnt = this.$store.state.qna_view.text.length;
      if (this.mtext == null) {
        return 0;
      }
      let cnt = this.mtext.length;
      if (cnt > 150) {
        this.mtext = this.mtext.substring(0, 150);
        this.cCount = 150;
      } else {
        this.cCount = cnt;
      }
    },
    goCancel() {
      let paperid = this.$route.params.paperid;
      this.$router.push("/qna/list/" + paperid);
    },
    goSave() {
      let url = this.$Constant.QnaListGetApi;
      let text = this.mtext;
      let paperid = this.$route.params.paperid;
      let $self = this;
      let msecret = this.secret ? 1 : 0;

      if (text.trim().length === 0) {
        alert("내용을 입력해 주세요");
        return;
      }

      this.$store.state.qna_pos = 1;
      this.$store.state.qna_more_count = 1;

      if (this.$store.getters.getQnaView.id === null) {
        this.$axios
          .post(url, {
            writer: $self.$store.getters.getDefaultInfo,
            text: text,
            paper_id: paperid,
            secret: msecret
          })
          .then(resp => {
            // console.log(resp.data);

            let paperid = this.$route.params.paperid;
            this.$router.replace("/qna/list/" + paperid);

            let payload = resp.data;
            payload.qna_id = payload.id;
            payload.deleted = false;
            payload.classroom_id = this.$store.getters.getClassroomId;
            let wrapper = {};
            wrapper.wayto = "ACTION_QNA_ADD";
            wrapper.from = "";
            wrapper.to = "";
            wrapper.payload = payload;
            this.$store.dispatch("pushWSMessage", wrapper);
          });
      } else {
        url =
          this.$Constant.QnaListGetApi +
          "/" +
          this.$store.getters.getQnaView.id;
        this.$axios
          .put(url, {
            writer: $self.$store.getters.getDefaultInfo,
            text: text,
            paper_id: paperid,
            secret: msecret,
            id: this.$store.getters.getQnaView.id
          })
          .then(() => {
            let paperid = this.$route.params.paperid;
            this.$router.replace("/qna/list/" + paperid);
          });
      }
    }
  }
};
</script>



